module.exports = __webpack_public_path__ + "a0f8152369c85a2045ddcba067dac230.svg";


//////////////////
// WEBPACK FOOTER
// ./app/components/PromotionBanner/images/Promotion_banner_Eve.svg
// module id = 1304
// module chunks = 3